import styled from 'styled-components';
import { palette } from 'styled-tools';

export const ServiceRegister = styled.div`
`;

export const Divider = styled.div`
    border-top: 1px solid ${palette('gray_opacity_100')};
    padding: 0 20px;
    margin-top: 24px;
`;